import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appNumbersOnly]'
})
export class NumbersOnlyDirective {

  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event']) onInput(event: any): void {
    const initialValue = this.el.nativeElement.value;
    const newValue = initialValue.replace(/[^0-9]/g, ''); // Remove non-numeric characters
    if (initialValue !== newValue) {
      this.el.nativeElement.value = newValue;
      event.preventDefault(); // Prevent the input of non-numeric characters
    }
  }
}
